import { createFileRoute } from "@tanstack/react-router"

import { SettingsTemplatesPage } from "@/pages/settings/templates"

// Every member reads the page; writes are gated in the page and by the API.
export const Route = createFileRoute("/_authenticated/settings/templates")({
  component: SettingsTemplatesPage,
})
